import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Frap from 'shared/app/components/frap-with-messages';
import { configImagesUrlSelector } from 'shared/app/state/selectors/config';

import LegacyPaddedContentColumn from 'shared/app/components/legacy-padded-content-column';

import messages from '../../messages';

const ForgotPasswordSuccess = ({ configImagesUrl }) => {
  return (
    <LegacyPaddedContentColumn className="text-bold text-sm" size="sm">
      <div className="flex justify-center py5">
        <img alt=" " src={`${configImagesUrl}/signin/key.svg`} width="150px" />
      </div>
      <p className="pt5">
        <FormattedMessage
          defaultMessage={
            "Thanks - if you have a Starbucks account, we've sent you an email."
          }
          description="Heading when reset password email is sent"
          id="accountSignin.forgotPasswordSuccess.successMessage"
        />
      </p>
      <div className="flex justify-end mt6">
        <Frap href="/account/signin">
          <FormattedMessage {...messages.returnToSigninText} />
        </Frap>
      </div>
    </LegacyPaddedContentColumn>
  );
  /* eslint-enable max-len */
};

ForgotPasswordSuccess.propTypes = {
  configImagesUrl: PropTypes.string.isRequired,
};

const select = (state) => ({
  configImagesUrl: configImagesUrlSelector(state),
});

export default connect(select)(ForgotPasswordSuccess);
